import React, { Component } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import RoleUtils from '../utils/roleUtils.js';
import CommonUtils from '../utils/siteUtils.js';
import '../styles/NavMenu.css';
import { refreshWorklistPage } from '../pages/VendorWorklist';
import { reloadPage } from '../components/RequestWorklist.js';
export class NavMenu extends Component {

    render() {
        const { currentUser, currentCompanyId } = this.props;
        var hasWorklistAccess = RoleUtils.determineMaintenanceModeNav(currentUser, currentCompanyId, RoleUtils.worklistPageAccessRoles());;
        var hasProfileAccess = RoleUtils.determineMaintenanceModeNav(currentUser, currentCompanyId, RoleUtils.profileRoles());;


        return (

            <Navbar expand="lg" id="navRowBar" className="align-items-center">

                <Navbar.Brand as={Link} to="/" id="siteTitle">UnitedHealth Group Payment Services Supplier Portal</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">

                        {(RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.inquiryPerms())) ?
                            <Nav.Link as={Link} to="/Search" className="navItemLink" href="/Search">Invoices/Payments</Nav.Link>
                            : <></>}
                        {(RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.editOnly())) ?
                            <Nav.Link as={Link} to="/Profile/Supplier/Access" className="navItemLink" href="/Profile/Supplier/Access">Portal Access</Nav.Link>
                            : <></>}
                        {(hasProfileAccess)
                            ? <Nav.Link as={Link} to="/Profile/Supplier" className="navItemLink" href="/Profile/Supplier">Supplier Profile</Nav.Link>
                            : <></>}
                        {(hasWorklistAccess)
                            ? <Nav.Link as={Link} to="/Worklist" className="navItemLink" href="/Worklist" reloadDocument={true}>Worklist</Nav.Link>
                            : <></>}
                        {(RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.allPerms())) ?
                            <Nav.Link as={Link} to="/Resources" className="navItemLink" href="/Search">Resources</Nav.Link>
                            : <></>}
                        {(RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.allPerms())) ?
                            <Nav.Link as={Link} to="/Inbox" className="navItemLink" href="/Inbox" reloadDocument={true}>Contact Us</Nav.Link>
                            : <></>}
                        {(RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.optumAdminPerms())) ?
                            <Nav.Link as={Link} to="/Admin" className="navItemLink">Administration</Nav.Link>
                            : <></>}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );

    }
}
